import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Folder, Trash2, Plus } from "lucide-react";

export default function FoldersPanel({ folders, events, onChange }) {
  const [name, setName] = useState("");
  const [eventId, setEventId] = useState("");
  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/media/folders", { name, event_id: eventId || null });
      toast.success("Cartella creata");
      setName(""); setEventId(""); onChange();
    } catch (err) { toast.error(err.response?.data?.detail || "Errore"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Eliminare la cartella e tutti i suoi file?")) return;
    await api.delete(`/media/folders/${id}`); toast.success("Cartella eliminata"); onChange();
  };
  return (
    <div>
      <form onSubmit={create} className="card-dark p-5 mb-6 grid md:grid-cols-[1fr_1fr_auto] gap-4 items-end" data-testid="folder-create-form">
        <div><div className="label-mono mb-1">NOME CARTELLA</div>
          <input required value={name} onChange={e=>setName(e.target.value)} className="input-dark" data-testid="folder-name"/></div>
        <div><div className="label-mono mb-1">EVENTO (opz.)</div>
          <select value={eventId} onChange={e=>setEventId(e.target.value)} className="input-dark bg-black" data-testid="folder-event">
            <option value="">—</option>
            {events.map(ev => <option key={ev.id} value={ev.id}>{ev.title}</option>)}
          </select></div>
        <button className="btn-primary !py-2 !px-4 text-xs flex items-center gap-1" data-testid="folder-create-btn"><Plus className="w-3 h-3"/>CREA</button>
      </form>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {folders.length === 0 && <div className="label-mono text-neutral-500">// NESSUNA CARTELLA</div>}
        {folders.map(f => (
          <div key={f.id} className="card-dark p-4 flex items-center gap-3" data-testid={`admin-folder-${f.id}`}>
            <Folder className="w-5 h-5 text-neon"/>
            <Link to={`/gallery/${f.id}`} className="flex-1 hover:text-neon">
              <div className="font-display text-base">{f.name}</div>
              <div className="font-mono text-[10px] text-neutral-500 tracking-widest">{f.count} FILE</div>
            </Link>
            <button onClick={()=>remove(f.id)} className="text-alert" data-testid={`folder-delete-${f.id}`}><Trash2 className="w-4 h-4"/></button>
          </div>
        ))}
      </div>
    </div>
  );
}
